module.exports = __webpack_public_path__ + "static/media/ricardo-perez-vial.a482dd02.svg";